import image1 from 'images/vegetables-small-png/vegetable-small-png-1.png';
import image2 from 'images/vegetables-small-png/vegetable-small-png-2.png';
import image3 from 'images/vegetables-small-png/vegetable-small-png-3.png';
import image4 from 'images/vegetables-small-png/vegetable-small-png-4.png';
import image5 from 'images/vegetables-small-png/vegetable-small-png-5.png';
import image6 from 'images/vegetables-small-png/vegetable-small-png-6.png';
import image7 from 'images/vegetables-small-png/vegetable-small-png-7.png';
import image8 from 'images/vegetables-small-png/vegetable-small-png-8.png';
import image9 from 'images/vegetables-small-png/vegetable-small-png-9.png';
import image10 from 'images/vegetables-small-png/vegetable-small-png-10.png';
import image11 from 'images/vegetables-small-png/vegetable-small-png-11.png';
import image12 from 'images/vegetables-small-png/vegetable-small-png-12.png';
import image13 from 'images/vegetables-small-png/vegetable-small-png-13.png';
import image14 from 'images/vegetables-small-png/vegetable-small-png-14.png';
import image15 from 'images/vegetables-small-png/vegetable-small-png-15.png';
import image16 from 'images/vegetables-small-png/vegetable-small-png-16.png';
import image17 from 'images/vegetables-small-png/vegetable-small-png-17.png';

export const data = [
    { img: image1 },
    { img: image2 },
    { img: image3 },
    { img: image4 },
    { img: image5 },
    { img: image6 },
    { img: image7 },
    { img: image8 },
    { img: image9 },
    { img: image10 },
    { img: image11 },
    { img: image12 },
    { img: image13 },
    { img: image14 },
    { img: image15 },
    { img: image16 },
    { img: image17 },
];
